import { useTranslations } from 'next-intl'

import { Card } from '@/entities/contract'

import { RefundTerm, type Props as RefundTermProps } from '../refund-term'
import {
  RefundInformationDetail,
  type Props as RefundInformationDetailProps,
} from './detail'

export type Props = RefundInformationDetailProps & RefundTermProps

export const RefundInformation = ({
  refundTerms,
  isOldRefundTerms,
  ...restProps
}: Props) => {
  const t = useTranslations('lease_detail.refund_information')

  return (
    <Card.Root spacing="large" className="border border-purple-500">
      <Card.Item>
        <Card.ItemTitle>{t('title')}</Card.ItemTitle>
        <Card.ItemContent className="space-y-6">
          <RefundInformationDetail
            isOldRefundTerms={isOldRefundTerms}
            {...restProps}
          />
          <RefundTerm
            isOldRefundTerms={isOldRefundTerms}
            refundTerms={refundTerms}
          />
        </Card.ItemContent>
      </Card.Item>
    </Card.Root>
  )
}
